module.exports = __webpack_public_path__ + "static/media/presencial.2d96acff.svg";